import React, { PureComponent } from 'react';

import { numberFormat } from '~/core/scripts/utils';
import { getPartyName } from '~/scripts/config';

class SimpleRanking extends PureComponent {
  render() {
    const { data } = this.props;

    if (!data) {
      return null;
    }

    return (
      <div className="simpleranking" {...this.props}>
        {data.map((d, i) => (
          <div className="simpleranking__item" key={`simpleranking__${d.name}`}>
            <div className="simpleranking__item-name">{i+1}. {getPartyName(d.name)}</div>
            <div className="simpleranking__item-value">{numberFormat(d.valueRel, 1)} %</div>
          </div>
        ))}
      </div>
    );
  }
}

export default SimpleRanking;
